import * as React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingButtonProps extends React.ComponentProps<typeof Button> {
  loading?: boolean;
  loadingText?: string;
}

const LoadingButton = React.forwardRef<
  React.ElementRef<typeof Button>,
  LoadingButtonProps
>(({ className, loading = false, loadingText, children, disabled, ...props }, ref) => {
  return (
    <Button
      className={cn(className)}
      disabled={disabled || loading}
      ref={ref}
      {...props}
    >
      {loading && (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      )}
      {loading ? (loadingText || "Loading...") : children}
    </Button>
  );
});

LoadingButton.displayName = "LoadingButton";

export { LoadingButton };